import Image from "next/image";
import { useContext, useEffect, useState } from "react";
import search_lamp_3 from "../../../../../shared-assets/images/search/search_lamp_3.png";
import { WeeklyTopSearchProduct } from "../../../../models/home-rows";
import { RootCategoryModel } from "../../../../models/root-category.model";
import { _, _c } from "../../../../services/text-services";
import Spinner from "../../spinner/spinner.component";
// @ts-ignore
import { useRouter } from "next/router";
import { SearchResponseBody } from "../../../../models/search-response";
import { API } from "../../../../services/api-services";
import AppContext from "../../../../services/app-context-services";
import { useLocalStorage } from "../../../../services/local-storage-services";
import { ROUTES } from "../../../../services/router-services";
import FetchData from "../../fetch-data/fetch-data";
import styles from "./search-dialog.component.module.scss";
import Imagic from "../../../../components/imagic/imagic";
import Link from "next/link";
import { trackEvent } from "../../../../services/ga-services";

interface SearchDialogProps {
  query: string;
  onCloseButton: () => void;
  isLoading: boolean;
  categories: RootCategoryModel[];
  defaultProducts: WeeklyTopSearchProduct[];
  searchResult: any[];
  isLogin: boolean;
  isMenu?: boolean;
  isMobile?: boolean;
  onSearchedKey: (key: string) => void;
  onSeeAllResults: () => void;
  searchInRootCategory: (catId: number) => void;
}

interface ResultRowProps {
  products: WeeklyTopSearchProduct[];
  title: string;
  query?: string;
  onSeeAllResults: () => void;
  onSelectProduct: () => void;
}

interface CategoriesProps {
  categories: RootCategoryModel[];
  selectedCat: number;
  onClickCategory: (catId: number) => void;
}

interface SearchedKeyProps {
  onSearchedKey: (key: string) => void;
}

function ResultRow({
  products,
  title,
  onSeeAllResults,
  onSelectProduct,
  query
}: ResultRowProps) {
  const router = useRouter();
  const appCtx = useContext(AppContext);
  const { isLoggedIn } = appCtx;
  // const [searchResponseBody, setSearchResponseBody] =
  //   useState<SearchResponseBody>();
  interface ClickedProduct extends WeeklyTopSearchProduct  {
    products?: WeeklyTopSearchProduct[];
    position?: number;
  };
  const [clickedProduct, setClickedProduct] = useState<ClickedProduct>();

  return (
    <div className={_c(styles, "searched-item")} id="weeklt-top">
      {!!clickedProduct?.id && query && (
        <FetchData
          url={API.request_search_response}
          method="POST"
          body={JSON.stringify({product_id: clickedProduct.id, query, position: clickedProduct.position})}
          unAuthorized={!isLoggedIn}
          counter={clickedProduct.id}
          with_dg_id
          onFinally={() => {
            onSelectProduct();
          }}
        />
      )}
      <div className={_c(styles, "title mb-3")}>
        <h3>{title}</h3>
        <hr />
      </div>
      <div id="items" className={_c(styles, "row")}>
        {products.slice(0, 6).map((item, i) => (
          <div
            key={item.id}
            className={_c(styles, "item col-4 col-md-2")}
            onClick={() => {
              if (!!query && query?.length > 2)
                setClickedProduct({...item, position: i + 1});
              else{
                onSelectProduct();
              }
            }}
          ><Link href={ROUTES.product(item)}>
            <a onClick={() => trackEvent("Search" , query, item?.id.toString())}>
              <Imagic
                src={item.avatar["hdpi"]}
                alt={item.name_english}
                className={_c(styles, "img-item")}
                width={141.3}
                height={203}
              //loader={simpleLoader}
              />
              <p>{_(item?.name)}</p>
            </a>
            </Link>
          </div>
        ))}
      </div>
      {products.length === 7 && (
        <div className={_c(styles, "more-result")}>
          <button onClick={() => {
            trackEvent("Search full result" , query)
            onSeeAllResults()
          }} className="py-2 px-3">
            مشاهده همه نتایج
          </button>
        </div>
      )}
    </div>
  );
}

function Categories({
  categories,
  selectedCat,
  onClickCategory
}: CategoriesProps) {
  return (
    <div
      className={_c(
        styles,
        "categories-wrapper d-flex justify-content-between"
      )}
    >
      <div
        className={_c(styles, "root-icon d-flex")}
        onClick={() => onClickCategory(0)}
      >
        <div className={`${_c(styles, "category-icon-all")} ${selectedCat === 0 ? styles.selected : ""
          }`}>
          <Image
            src="/images/icons/all-icon.svg"
            width={20}
            height={20}
            alt="all-icon"
          />
        </div>
        <p
          className={`${_c(styles, "mr-1")} ${selectedCat === 0 ? styles.selected : ""
            } `}
        >
          همه
        </p>
      </div>
      {categories.map(category => (
        <div
          onClick={() => {
            onClickCategory(category.id);
          }}
          key={category.id}
          className={_c(styles, "root-icon d-flex")}
        >
          {category?.avatar && <div className={`${_c(styles, "category-icon")} ${selectedCat === category.id ? styles.selected : ""
            } `}>
            <Imagic
              src={category.avatar}
              width={25}
              height={25}
              alt="category-avatar"
            />
          </div>}
          <p
            className={`${_c(styles, "mr-1")} ${selectedCat === category.id ? styles.selected : ""
              } `}
          >
            {category.title}
          </p>
        </div>
      ))}
    </div>
  );
}

function SearchedKey({ onSearchedKey }: SearchedKeyProps) {
  const { storedValue: localKeyword, setValue: setLocalKeyword } =
    useLocalStorage("keyword", "");
  const [searchedKeywords, setSearchedKeywords] = useState(
    localKeyword ? JSON.parse(localKeyword) : []
  );

  const removedKeyword = (key: string) => {
    let removedKeywordArr = searchedKeywords.filter((item: string) => {
      return item !== key;
    });
    setSearchedKeywords(removedKeywordArr);
    setLocalKeyword(removedKeywordArr);
  };

  return (
    <>
      <div className="title mb-3">
        <h3>کلمات جستجو شده:</h3>
        <hr />
      </div>
      <div id="items" className="d-flex flex-wrap">
        {searchedKeywords.slice(0, 6).map((item: string) => {
          <div
            className={_c(styles, "item d-flex justify-content-center mb-1")}
            onClick={() => {
              onSearchedKey(item);
            }}
          >
            <span>{item.length > 10 ? item.slice(0, 9) + ".." : item}</span>
            <span
              className={_c(styles, "close")}
              onClick={() => {
                removedKeyword(item);
              }}
            >
              {" "}
            </span>
          </div>;
        })}
      </div>
    </>
  );
}

function SearchDialog({
  query,
  isLoading,
  isLogin,
  categories,
  onCloseButton,
  defaultProducts,
  searchResult,
  isMenu,
  isMobile,
  onSearchedKey,
  searchInRootCategory,
  onSeeAllResults
}: SearchDialogProps) {
  const [selectedCat, setSelectedCat] = useState<number>(0);
  const router = useRouter();

  return (
    <div
      onClick={() => onCloseButton()}
      onKeyDown={e => e.key === "Escape" && onCloseButton()}
      className={_c(
        styles,
        (isMobile ? "is-mobile " : "is-desktop ") +
        (isMobile ? "" : isMenu ? "is-menu " : "is-home ") +
        "search-box show col-12"
      )}
      tabIndex={0}
    >
      {/* <!-- Close button --> */}
      <div className={_c(styles, "close-fixed-btn")}>
        <div className={_c(styles, "close")}></div>
      </div>

      {/* <!-- DESKTOP SECTION --> */}
      <div
        className={_c(styles, "box-content")}
        onClick={e => e.stopPropagation()}
      >
        <Categories
          categories={categories}
          selectedCat={selectedCat}
          onClickCategory={categoryId => {
            setSelectedCat(categoryId);
            searchInRootCategory(categoryId);
          }}
        />
        {isLoading ? (
          <Spinner type="tiny" />
        ) : (
          <div>
            {/* <!-- search result --> */}
            {searchResult && searchResult.length > 0 && (
              <ResultRow
                products={searchResult}
                title={"نتایج جستجوی شما:"}
                query={query}
                onSeeAllResults={onSeeAllResults}
                onSelectProduct={onCloseButton}
              />
            )}
            {/* <!-- no result --> */}
            {searchResult && searchResult.length == 0 && query && (
              <div
                className={_c(styles, "searched-item no-result")}
                id="search-result"
              >
                <Image
                  src={search_lamp_3}
                  alt="search"
                  width={100}
                  height={130}
                  className={_c(styles, "serach-img")}
                //loader={simpleLoader}
                />
                <p>متاسفانه نتیجه ای پیدا نشد</p>
              </div>
            )}

            {/* <!-- weekly top search : for logged out users and  recently search for logged in users--> */}
            {searchResult.length == 0 && defaultProducts && (
              <ResultRow
                products={defaultProducts}
                title={isLogin ? "جستجوی های اخیر شما:" : "بیشترین جستجو:"}
                onSeeAllResults={onSeeAllResults}
                onSelectProduct={onCloseButton}
              />
            )}

            {/* <!-- searched words--> */}
            {/* {searchResult.length == 0 && (
              <div className={_c(styles, "keyword-searched searched-item")}>
                <SearchedKey onSearchedKey={(key) => {onSearchedKey(key)}}/>
              </div>
            )} */}
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchDialog;
